import React, { useState } from "react"
import { ALL_CATEGORIES } from "../VenueServicesList"

import style from "./index.module.sass"

function SectionsList(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { sections, selectedSection, onClick } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [isAZSort, setIsAZSort] = useState(false)

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function renderAZSort() {
    return (
      <div className={style.azSort} onClick={() => setIsAZSort(!isAZSort)}>
        <i className="fas fa-sort-alpha-down"></i>
      </div>
    )
  }

  function azSort(a, b) {
    if (a.title > b.title) return 1
    if (a.title < b.title) return -1
    return 0
  }

  function sortSections() {
    let sorted = [...sections]
    sorted.sort(azSort)

    return sorted
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let sorted = isAZSort ? sortSections() : sections

  // -------------------------------------

  return (
    <div className={style.sectionsContainer}>
      {renderAZSort()}

      <div
        className={`${style.sectionTitle} ${
          ALL_CATEGORIES === selectedSection?.id ? style.selected : ""
        }`}
        onClick={() => onClick({ id: ALL_CATEGORIES })}
      >
        {I18n.t("service_ordering.all_categories")}
      </div>

      {sorted.map((section) => {
        let sectionClass = style.sectionTitle

        if (section.id === selectedSection?.id) {
          sectionClass += " " + style.selected
        }

        return (
          <div
            key={section.id}
            className={sectionClass}
            onClick={() => onClick(section)}
          >
            {section.title}
          </div>
        )
      })}
    </div>
  )
}

// ----------------------------------------------------------------------------

export default SectionsList
